import { Panels } from './panels/Consts';
import * as dayjs from 'dayjs'
import 'dayjs/locale/ru';
import 'dayjs/locale/en';
import * as updateLocale from 'dayjs/plugin/updateLocale';
import * as calendar from 'dayjs/plugin/calendar';
import * as localizedFormat from 'dayjs/plugin/localizedFormat';
import { Modals } from './Consts';
import * as Sentry from '@sentry/browser';
import CreditsBlockComponent from './panels/Events/components/CreditsBlockComponent';
dayjs.extend(calendar)
dayjs.extend(updateLocale)
dayjs.extend(localizedFormat)

const Langs = {
  app: {
    back_label: {
      ru: 'Назад',
      en: 'Back',
    },
    month_jan: {
      ru: 'янв',
      en: 'jan',
    },
    month_feb: {
      ru: 'фев',
      en: 'feb',
    },
    month_mar: {
      ru: 'мар',
      en: 'mar',
    },
    month_apr: {
      ru: 'апр',
      en: 'apr',
    },
    month_may: {
      ru: 'май',
      en: 'may',
    },
    month_jun: {
      ru: 'июн',
      en: 'jun',
    },
    month_jul: {
      ru: 'июл',
      en: 'jul',
    },
    month_aug: {
      ru: 'авг',
      en: 'aug',
    },
    month_sep: {
      ru: 'сен',
      en: 'sep',
    },
    month_oct: {
      ru: 'окт',
      en: 'oct',
    },
    month_nov: {
      ru: 'ноя',
      en: 'nov',
    },
    month_dec: {
      ru: 'дек',
      en: 'dec',
    },
    dateTimeFormat: {
      ru: '%d %m в %h:%i',
      en: '%d %m in %h:%i',
    },
    error_modal_title: {
      ru: 'Ошибка',
      en: 'Error',
    },
    error_modal_message: {
      ru: 'Упс, ошибочка вышла!',
      en: 'Oops, an error occurred!',
    },
    error_modal_platform_dont_supported_message: {
      ru: 'Платформа не поддерживается',
      en: 'This platform is not supported',
    },
    error_modal_access_error_message: {
      ru: 'Нет доступа',
      en: 'Access denied',
    },
    error_modal_not_found_error_message: {
      ru: 'Мы не смогли найти ничего по вашему запросу',
      en: 'Sorry, no matches were found for your query.',
    },
    distribution_type_label_equally: {
      ru: 'Поровну',
      en: 'Equally',
    },
    distribution_type_label_value: {
      ru: 'Суммой',
      en: 'Sum',
    },
    distribution_type_label_parts: {
      ru: 'Пропорцией',
      en: 'Proportion',
    },
    distribution_type_tab_placeholder: {
      ru: 'Введите сумму и выберите участников для расчета',
      en: 'Enter the cost and select members for calculate',
    },
    app_name: {
      ru: 'Who2who',
      en: 'Who2who',
    },
    reload_button_label: {
      ru: 'Обновить',
      en: 'Update',
    },
    save_label: {
      ru: 'Сохранить',
      en: 'Save',
    },
    name_input_label: {
      ru: 'Название',
      en: 'Name',
    },
    status_input_label: {
      ru: 'Статус',
      en: 'Status',
    },
    status_label_payments: {
      ru: 'Сбор расходов',
      en: 'Payments',
    },
    status_label_repayments: {
      ru: 'Сбор возвратов',
      en: 'Repayments',
    },
    status_label_all: {
      ru: 'Принимать всё',
      en: 'All',
    },
    status_label_archived: {
      ru: 'Архив',
      en: 'Archived',
    },
    image_input_label: {
      ru: 'Картинка',
      en: 'Image',
    },
    image_button_label__empty: {
      ru: 'Выбрать фото',
      en: 'Select photo',
    },
    image_button_label__selected: {
      ru: 'Выбрано %count',
      en: 'Selected %count',
    },
    comment_input_label: {
      ru: 'Комментарий',
      en: 'Comment',
    },
    amount_input_label: {
      ru: 'Сумма',
      en: 'Amount',
    },
    date_input_label: {
      ru: 'Дата',
      en: 'Date',
    },
    all_members_items_label: {
      ru: 'Все',
      en: 'All members',
    },
    members_input_label: {
      ru: 'Участники',
      en: 'Members',
    },
    members_input_placeholder: {
      ru: 'Не выбраны',
      en: 'Not selected',
    },
    creator_input_label: {
      ru: 'Кто оплачивал',
      en: 'Who paid',
    },
    creator_input_placeholder: {
      ru: 'Не выбран',
      en: 'Not selected',
    },
    add_joined_members_input_label: {
      ru: 'Автоматически добавлять новых участников',
      en: 'Automatically add new members',
    },
    edit_button_label: {
      ru: 'Редактировать',
      en: 'Edit',
    },
    delete_button_label: {
      ru: 'Удалить',
      en: 'Delete',
    },
    confirm_delete_message: {
      ru: 'Точно удалить?',
      en: 'Are you sure you want to delete?',
    },
    confirm_delete_ok_label: {
      ru: 'Да',
      en: 'Yes',
    },
    confirm_delete_cancel_label: {
      ru: 'Нет',
      en: 'No',
    },
    client_version: {
      ru: 'Версия клиента %version',
      en: 'Client version %version'
    },
    add_to_chat_title: {
      ru: 'Who2who - разделить расходы',
      en: 'Who2who - share expenses'
    },
    create_payment_confirm_for_archived: {
      ru: 'Событие находится в архиве. Чтобы добавить изменения, переведите его в активный статус в настройках.',
      en: 'The event is archived. To add changes, switch it to active status in the settings.',
    },
    create_payment_confirm_for_repayments: {
      ru: 'Сейчас открыт этап возвратов. Чтобы добавить новые траты, измените статус события в настройках.',
      en: 'The refund stage is now open. To add new expenses, change the event status in the settings.',
    },
    create_payment_confirm_for_payments: {
      ru: 'Сейчас можно добавлять только траты. Чтобы внести возврат, измените статус события в настройках.',
      en: 'Currently, you can only add expenses. To make a refund, change the event status in the settings.',
    },
    create_items_confirm_button_label_ok: {
      ru: 'Я понял',
      en: 'OK',
    },
    create_items_confirm_button_label_settings: {
      ru: 'Настройки',
      en: 'Settings',
    },
  },
  errors: {
    loadData: {
      ru: 'Произошла ошибка при загрузке данных, попробуйте позже',
      en: 'There was an error loading the data, please try again later',
    },
    tooManyAttempts: {
      ru: 'Слишком много запросов. Остановитесь!',
      en: 'Too many requests. Stop!',
    },
    unknownError: {
      ru: 'Упс, ошибочка вышла!',
      en: 'Oops, an error occurred!',
    },
    notFound: {
      ru: 'Мы не смогли найти ничего по вашему запросу',
      en: 'Sorry, no matches were found for your query',
    },
    accessDenied: {
      ru: 'Нет доступа',
      en: 'Access denied',
    },
    platformNotSupported: {
      ru: 'Платформа не поддерживается',
      en: 'This platform is not supported',
    },
    image_error_max_size: {
      ru: 'Максимальный размер изображения %sizeMb',
      en: 'Maximum image size %sizeMb',
    },
    name_error_min_length_2_char: {
      ru: 'Количество символов должно быть не меньше 2',
      en: 'The number of characters must be at least 2',
    },
    name_error_min_length_3_char: {
      ru: 'Количество символов должно быть не меньше 3',
      en: 'The number of characters must be at least 3',
    },
    comment_error_max_length_255_char: {
      ru: 'Максимальная длинна 255 символов',
      en: 'Maximum length 255 characters',
    },
    amount_error_min: {
      ru: 'Минимальная сумма 0.01',
      en: 'Minimum amount 0.01',
    },
    amount_error_max: {
      ru: 'Превышено максимальное значение',
      en: 'Maximum value exceeded',
    },
    date_error_min: {
      ru: 'Дата может быть +- 1 год',
      en: 'Date can be +- 1 year',
    },
    date_error_max: {
      ru: 'Дата может быть +- 1 год',
      en: 'Date can be +- 1 year',
    },
    image_error_type: {
      ru: 'Разрешенные форматы png, jpeg, webp',
      en: 'Allowed formats are png, jpeg, webp',
    },
    image_error_max_count: {
      ru: 'Максимальное кол-во файлов 10',
      en: 'Maximum number of files 10',
    },
    excess_total_amount: {
      ru: 'Превышена общая сумма',
      en: 'Total amount exceeded',
    },
    dataValidation: {
      ru: 'Ошибка валидации данных',
      en: 'Data validation error',
    },
    upgradeRequired: {
      ru: 'Ваша версия приложения устарела и оно не может корректно работать\n' +
        'Пожалуйста, обновите его, или воспользуйтесь web версией {link_web_m}',
      en: 'Your application is outdated and may not work correctly\n' +
        'Please update it, or use the web version {link_web_m}',
    },
    upgradeRequiredTelegram: {
      ru: 'Ваша версия приложения устарела и оно не может корректно работать\n' +
        'Пожалуйста сбросте кеш и переоткройте приложение',
      en: 'Your application is outdated and may not work correctly\n' +
        'Please clear cache and reopen the app',
    },
    networkError: {
      ru: 'Ошибка подключения',
      en: 'Connection error',
    },
    errorScanCashReceipt: {
      ru: 'Не получилось распознать чек',
      en: 'The receipt cannot be recognized',
    },
  },
  ScanReceiptButtonComponent: {
    qr_scan_actions_text_position: {
      ru: [
        'позиция',
        'позиции',
        'позиций',
      ],
      en: [
        'position',
        'positions',
      ],
    },
    qr_scan_action_one_sum_title: {
      ru: 'Одной суммой',
      en: 'One sum',
    },
    qr_scan_action_by_positions_title: {
      ru: 'По позициям',
      en: 'By positions',
    },
    qr_scan_action_add_title: {
      ru: 'Добавить',
      en: 'Add',
    },
    qr_scan_actions_text_one_position: {
      ru: 'В чеке 1 позиция, желаете добавить ее?',
      en: 'There is 1 item in the receipt, would you like to add it?',
    },
    qr_scan_actions_text: {
      ru: 'В чеке %countItems %position. Добавить их одной суммой или расписать по позициям?',
      en: 'In the receipt %countItems %position. Add them in one amount or paint them by positions?',
    },
    error: {

    },
    button_label__open_camera: {
      ru: 'Открыть камеру',
      en: 'Open camera',
    },
    button_label__open_gallery: {
      ru: 'Открыть галерею',
      en: 'Open gallery',
    }
  },
  users_stack: {
    short_separator: {
      ru: ' и ',
      en: ' and ',
    },
    long_separator: {
      ru: ', ',
      en: ', ',
    },
    long_tail: {
      ru: ' и еще %countMembers человека',
      en: ' and %countMembers members',
    },
  },
  [Panels.EDIT_PAYMENT_PANEL]: {
    header: {
      ru: 'Редактирование траты',
      en: 'Edit payment',
    },
    images_delete_checkbox_label: {
      ru: 'Удалить',
      en: 'Delete',
    },
    button_save_label: {
      ru: 'Сохранить',
      en: 'Save',
    },
  },
  OnBoarding: {
    slide_about_title: {
      ru: 'who2who',
      en: 'who2who',
    },
    slide_about_text: {
      ru: 'Приложение, которое поможет разделить совместные траты и управлять ими',
      en: 'An application that will help you share and manage joint expenses',
    },
    slide_profile_title: {
      ru: 'Профиль',
      en: 'Profile',
    },
    slide_profile_text: {
      ru: 'Заполните профиль, указав номер, на который нужно будет перевести деньги, и приоритетный банк',
      en: 'Fill out the profile, indicating the number to which the money will need to be transferred, and the priority bank',
    },
    slide_notify_title: {
      ru: 'Уведомления',
      en: 'Notifications',
    },
    slide_notify_text: {
      ru: 'Настройте уведомления, чтобы быть в курсе расходов и возвратов',
      en: 'Set up notifications to stay up to date on expenses and refunds',
    },
    slide_credits_title: {
      ru: 'Событие',
      en: 'Event',
    },
    slide_credits_text: {
      ru: 'Создайте событие, придумав ему название и загрузив картинку по желанию. Добавьте участников и сумму, а приложение произведет все расчёты.',
      en: 'Create an event by giving it a name and uploading an image. Add participants and amounts, and the application will make all the calculations.',
    },
    slide_friends_title: {
      ru: 'Друзья',
      en: 'Friends',
    },
    slide_friends_text: {
      ru: 'Пригласите друзей, чтобы все могли наблюдать за расходами и контролировать возврат денег',
      en: 'Invite friends so everyone can watch spending and control refunds',
    },
    slide_create_payment_title: {
      ru: 'Расходы',
      en: 'Expenses',
    },
    slide_create_payment_text: {
      ru: 'Внесите траты вручную или отсканируйте чеки',
      en: 'Enter expenses manually or scan receipts',
    },
    button_skip_label: {
      ru: 'Пропустить',
      en: 'Skip',
    },
    button_next_label: {
      ru: 'Далее',
      en: 'Next',
    },
    button_finish_label: {
      ru: 'Хорошо',
      en: 'Go',
    },
  },
  [Panels.PROFILE_PANEL]: {
    header: {
      ru: 'Профиль',
      en: 'Profile',
    },
    payment_info_label: {
      ru: 'Номер телефона или карты',
      en: 'Phone or card number',
    },
    payment_info_description: {
      ru: 'По этим данным вам будут переводить деньги, если к телефону привязано несколько банков, укажите какой удобнее',
      en: 'Enter your phone number or card number so they can transfer money to you. If the phone number is associated with several banks, write which one is more convenient',
    },
    payment_info_placeholder: {
      ru: 'Тинькофф +7 900 123 12 12 \nили \n1234 4567 7654 4321',
      en: 'Tinkoff +7 900 123 12 12 \nor \n1234 4567 7654 4321',
    },
    notifications_header: {
      ru: 'Уведомления',
      en: 'Notifications',
    },
    notify_user_joined_event_label: {
      ru: 'Новый участник в событии',
      en: 'New member in event',
    },
    notify_user_added_payment_label: {
      ru: 'Новая трата',
      en: 'New expense',
    },
    notify_enable_label: {
      ru: 'Включить',
      en: 'Enable notifications',
    },
  },
  VkScanReceipt: {
    header: {
      ru: 'Лимиты',
      en: 'Limits',
    },
    receipt_scans_header: {
      ru: 'Сейчас вам доступно',
      en: 'Available to you now',
    },
    receipt_scans_button_label: {
      ru: 'Купить',
      en: 'Buy',
    },
    remaining_receipt_scans_count: {
      ru: [
        '%number сканирование',
        '%number сканирования',
        '%number сканирований',
      ],
      en: [
        '%number scan',
        '%number scans'
      ]
    },
    events_header: {
      ru: 'Сейчас вам доступно',
      en: 'Available to you now',
    },
    events_button_label: {
      ru: 'Купить',
      en: 'Buy',
    },
    remaining_events_count: {
      ru: [
        '%number событие',
        '%number события',
        '%number событий',
      ],
      en: [
        '%number event',
        '%number events'
      ]
    },
  },
  [Modals.BUY_RECEIPT_SCANS_MODAL]: {
    values_header: {
      ru: 'Количество сканирований',
      en: 'Number of scans',
    },
    values_comment: {
      ru: '1 голос = 1 сканирование',
      en: '1 vote = 1 scan',
    },
    button_buy_label: {
      ru: 'Купить',
      en: 'Buy',
    },
  },
  [Modals.BUY_EVENTS_MODAL]: {
    values_header: {
      ru: 'Количество событий',
      en: 'Number of events',
    },
    values_comment: {
      ru: '5 голосов = 1 событие',
      en: '5 votes = 1 event',
    },
    button_buy_label: {
      ru: 'Купить',
      en: 'Buy',
    },
  },
  [Modals.CREATE_EVENT_MODAL]: {
    header: {
      ru: 'Новое событие',
      en: 'New event',
    },
    save_button: {
      ru: 'Создать событие',
      en: 'Add new event',
    },
    create_count_limit: {
      ru: 'Вы можете создавать до 5 событий в течение 30 дней.',
      en: 'You can create up to 5 events within 30 days.',
    },
    generate_image_confirm_text: {
      ru: 'Нейросеть может сгенерировать изображение для события по названию. Картинка появится чуть позже',
      en: 'Neural network can generate the image for your event by name. The picture will appear a little later',
    },
    generate_image_ok_label: {
      ru: 'Сгенерировать',
      en: 'Generate',
    },
    generate_image_cancel_label: {
      ru: 'Не нужно',
      en: 'No, thanks',
    }
  },
  [Panels.EVENTS_LIST]: {
    header: {
      ru: 'Список событий',
      en: 'Event list',
    },
    createEventButton: {
      ru: 'Добавить событие',
      en: 'Add event',
    },
    emptyListContentLine1: {
      ru: 'Добавляйте события, чеки',
      en: 'Add events, receipts',
    },
    emptyListContentLine2: {
      ru: 'и друзей, чтобы выяснить',
      en: 'and friends to find out',
    },
    emptyListContentLine3: {
      ru: 'кто - кому - сколько должен',
      en: 'Who and how much should return',
    },
    profile_button_label: {
      ru: 'Профиль',
      en: 'Profile',
    },
    moreLoadButton: {
      ru: 'Загрузить еще',
      en: 'Load more',
    },
    searchEmptyList: {
      ru: 'Мы не смогли ничего найти по вашему запросу',
      en: 'We couldn\'t find anything for your request',
    },
    searchPlaceholder: {
      ru: 'Поиск',
      en: 'Search',
    },
    event_share_button: {
      ru: 'Поделиться',
      en: 'Share',
    },
    im_attach_picker_confirm_text: {
      ru: 'Желаете создать событие для чата?',
      en: 'Want to create a chat event?',
    },
    im_attach_picker_confirm_label_ok: {
      ru: 'Создать',
      en: 'Create',
    },
    im_attach_picker_confirm_label_cancel: {
      ru: 'Выбрать существующее',
      en: 'Select from existing',
    },
  },
  [Panels.EVENT_INFO]: {
    header: {
      ru: 'Событие',
      en: 'Event',
    },
    scan_qr: {
      ru: 'Сканировать QR',
      en: 'Scan QR',
    },
    scan_receipt_label: {
      ru: 'Сканировать чек',
      en: 'Scan cash receipt',
    },
    scan_receipts_list_label: {
      ru: 'Чеки',
      en: 'cash receipts',
    },
    add_payment: {
      ru: 'Добавить расходы',
      en: 'Add expenses',
    },
    settings_button: {
      ru: 'Настройки',
      en: 'Settings',
    },
    load_items_button: {
      ru: 'Загрузить еще',
      en: 'Load more',
    },
    payments_list_empty: {
      ru: 'Добавляйте расходы и участников, чтобы получился расчёт',
      en: 'Add expenses and participants to get a calculation',
    },
    payments_nums: {
      ru: [
        'оплата',
        'оплаты',
        'оплат',
      ],
      en: [
        'payment',
        'payments'
      ],
    },
    search_not_found_items: {
      ru: 'Расходы не найдены',
      en: 'Expenses not found',
    },
    itog_header: {
      ru: 'Итого',
      en: 'Total',
    },
    itog_text_1: {
      ru: 'Расчёт за событие',
      en: 'Payment for event',
    },
    itog_text_2: {
      ru: 'Кто - кому - сколько должен',
      en: 'Who and how much should return',
    },
    qr_scan_actions_header: {
      ru: 'Подтвердите действие',
      en: 'Confirm the action',
    },
    qr_scan_actions_text: {
      ru: 'В чеке %countItems %position. Добавить их одной суммой или расписать по позициям?',
      en: 'In the receipt %countItems %position. Add them in one amount or paint them by positions?',
    },
    qr_scan_actions_text_position: {
      ru: [
        'позиция',
        'позиции',
        'позиций',
      ],
      en: [
        'position',
        'positions',
      ],
    },
    qr_scan_action_1_title: {
      ru: 'По позициям',
      en: 'By positions',
    },
    qr_scan_action_2_title: {
      ru: 'Одной суммой',
      en: 'One sum',
    },
    send_invite_button: {
      ru: 'Пригласить друзей',
      en: 'Invite friends',
    },
    invite_copy_success: {
      ru: 'Ссылка скопирована в буфер обмена',
      en: 'Link copied to clipboard',
    },
    send_invite_success: {
      ru: 'Ссылка отправлена тебе в личном сообщении',
      en: 'Link sent to you personally',
    },
    add_repayment: {
      ru: 'Вернуть',
      en: 'Refund money',
    },
    share_event_link_after_crate_confirm_text: {
      ru: 'Поделиться ссылкой с друзьями?',
      en: 'Share link with friends?'
    },
    share_event_link_after_crate_confirm_ok_label: {
      ru: 'Да',
      en: 'Yes'
    },
    share_event_link_after_crate_confirm_cancel_label: {
      ru: 'Позже',
      en: 'Later'
    },
    empty_list_label: {
      ru: 'Пусто',
      en: 'Empty'
    }
  },
  [Panels.EVENT_SETTINGS]: {
    header: {
      ru: 'Настройки события',
      en: 'Event settings',
    },
    users_block_header: {
      ru: 'Пользователи',
      en: 'Members',
    },
    qr_code_description: {
      ru: 'Если пользователя нет у вас в друзьях, покажите ему QR-код',
      en: 'If the user is not among your friends, show the QR-code',
    },
    invite_link_description: {
      ru: 'Или отправьте ссылку',
      en: 'Or send a link',
    },
    invite_link_update_button: {
      ru: 'Обновить ссылку приглашения',
      en: 'Update invitation link',
    },
    button_save_label: {
      ru: 'Сохранить',
      en: 'Save',
    },
    invite_copy_to_clipboard: {
      ru: 'Ссылка скопирована в буфер обмена',
      en: 'Link copied to clipboard',
    },
    button_leave_label: {
      ru: 'Покинуть событие',
      en: 'Leave event',
    },
    leave_event_text: {
      ru: 'Вы точно хотите покинуть событие?',
      en: 'Are you sure you want to leave the event?',
    },
    leave_event_go: {
      ru: 'Да',
      en: 'Yes',
    },
    leave_event_cancel: {
      ru: 'Нет',
      en: 'No',
    },
    button_send_generate_image: {
      ru: 'Создать картинку',
      en: 'Create image',
    },
    generating_image: {
      ru: 'Создаем',
      en: 'Creating',
    }
  },
  [Panels.SCAN_RECEIPTS_LIST_PANEL]: {
    header: {
      ru: 'Чеки',
      en: 'Cash receipts',
    },
    moreLoadButton: {
      ru: 'Загрузить еще',
      en: 'Load more',
    },
    status_label__error: {
      ru: 'Ошибка',
      en: 'Error',
    },
    status_label__wait: {
      ru: 'в обработке',
      en: 'wait',
    },
    status_label__finish: {
      ru: 'Готов',
      en: 'Done',
    },
    description: {
      ru: [
        '%totalCountItems позиция, на %totalAmount',
        '%totalCountItems позиции, на %totalAmount',
        '%totalCountItems позиций, на %totalAmount',
      ],
      en: [
        '%totalCountItems position, for %totalAmount',
        '%totalCountItems positions, for %totalAmount',
      ],
    },
    emptyList: {
      ru: 'Пока в событии не сканировали ни одного чека',
      en: 'So far, no receipts have been scanned in event',
    }
  },
  [Panels.SCAN_RECEIPT_PANEL]: {
    header: {
      ru: 'Информация о чеке',
      en: 'Cash receipt info',
    },
    status_label__error: {
      ru: 'Ошибка',
      en: 'Error',
    },
    status_label__wait: {
      ru: 'в обработке',
      en: 'wait',
    },
    status_label__finish: {
      ru: 'Готов',
      en: 'Done',
    },
    button_action__one_sum_label: {
      ru: 'Добавить одной суммой',
      en: 'Add in one',
    },
    button_action__by_positions_label: {
      ru: 'Добавить по позициям',
      en: 'Add by positions',
    },
    row_title__status: {
      ru: 'Статус',
      en: 'Status',
    },
    row_title__total_amount: {
      ru: 'Сумма',
      en: 'Amount',
    },
    row_title__total_count_items: {
      ru: 'Позиций в чеке',
      en: 'Positions in receipt',
    },
    row_title__items: {
      ru: 'Позиции',
      en: 'Positions',
    }
  },
  [Panels.CREATE_PAYMENT_PANEL]: {
    header: {
      ru: 'Добавить расходы',
      en: 'Add expenses',
    },
    button_save_label: {
      ru: 'Добавить',
      en: 'Add',
    },
  },
  [Panels.CREATE_PAYMENT_FROM_QR_CODE_PANEL]: {
    header: {
      ru: 'Добавление по списку',
      en: 'Add list',
    },
    button_save_label: {
      ru: 'Добавить',
      en: 'Add',
    },
  },
  [Panels.PAYMENT_INFO_PANEL]: {
    payment_man_description: {
      ru: 'Оплатил %amount',
      en: 'Paid %amount',
    },
  },
  [Panels.REPAYMENT_INFO_PANEL]: {
    header: {
      ru: 'Возврат',
      en: 'Repay the debt',
    },
    confirm_delete_header: {
      ru: 'Удаление',
      en: 'Deleting',
    },
    confirm_delete_text: {
      ru: 'Вы точно желаете удалить?',
      en: 'Are you sure you want to delete?',
    },
    confirm_delete_yes_button: {
      ru: 'Да',
      en: 'Yes',
    },
    confirm_delete_no_button: {
      ru: 'Нет',
      en: 'No',
    },
    from_label: {
      ru: 'Кто',
      en: 'Who',
    },
    to_label: {
      ru: 'Кому',
      en: 'To whom',
    },
  },
  [Panels.INVITE_PANEL]: {
    error_invite_length: {
      ru: 'Инвайт не найден, возможно он уже устарел',
      en: 'Invitation not found!',
    },
    reload_button_label: {
      ru: 'Домой',
      en: 'To home',
    }
  },
  [Panels.CREATE_PAYMENTS_FROM_QR_CODE_PANEL]: {
    header: {
      ru: 'Добавление трат',
      en: 'Add an expense',
    },
    skip_label: {
      ru: 'Не добавлять',
      en: 'Do not add',
    },
    button_save_label: {
      ru: 'Добавить',
      en: 'Add',
    },
  },
  [Panels.CREATE_REPAYMENT_PANEL]: {
    header: {
      ru: 'Возврат долга',
      en: 'Debt repayment',
    },
    user_from: {
      ru: 'Кто (переводит деньги)',
      en: 'Who (transfers money)',
    },
    user_from_placeholder: {
      ru: 'Кто переводит деньги',
      en: 'Who transfers money',
    },
    user_to: {
      ru: 'Кому (возвращаются деньги)',
      en: 'Whom (gets money)',
    },
    user_to_placeholder: {
      ru: 'Кому возвращаются деньги',
      en: 'Who gets money',
    },
    button_vk_pay_label: {
      ru: 'Перевод VK Pay',
      en: 'VK Pay transfer',
    },
    button_save_label: {
      ru: 'Вернуть долг',
      en: 'Repay the debt',
    },
  },
  [Panels.EDIT_REPAYMENT_PANEL]: {
    header: {
      ru: 'Возврат долга',
      en: 'Debt repayment',
    },
    user_from: {
      ru: 'Кто (переводит деньги)',
      en: 'Who (transfers money)',
    },
    user_from_placeholder: {
      ru: 'Кто переводит деньги',
      en: 'Who transfers money',
    },
    user_to: {
      ru: 'Кому (возвращаются деньги)',
      en: 'Whom (gets money)',
    },
    user_to_placeholder: {
      ru: 'Кому возвращаются деньги',
      en: 'Who gets money',
    },
    images_delete_checkbox_label: {
      ru: 'Удалить',
      en: 'Delete',
    },
    button_save_label: {
      ru: 'Сохранить',
      en: 'Save',
    },
  },
  CreditsBlockComponent: {
    tab_i: {
      ru: 'Я',
      en: 'I',
    },
    tab_me: {
      ru: 'Мне',
      en: 'Me',
    },
    tab_all: {
      ru: 'Все',
      en: 'All',
    },
  },
  [Panels.EVENTS_ARCHIVE_LIST]: {
    emptyListContentLine1: {
      ru: 'В архиве пока нет событий. 📦',
      en: 'There are no events in the archive yet. 📦',
    },
    emptyListContentLine2: {
      ru: 'Когда вы завершите событие, оно появится здесь.',
      en: 'When you finish an event, it will appear here.',
    },
    searchEmptyList: {
      ru: 'Мы не смогли ничего найти по вашему запросу',
      en: 'We couldn\'t find anything for your request',
    },
    profile_button_label: {
      ru: 'Профиль',
      en: 'Profile',
    },
    searchPlaceholder: {
      ru: 'Поиск',
      en: 'Search',
    },
    header: {
      ru: 'Архив',
      en: 'Archive',
    },
    moreLoadButton: {
      ru: 'Загрузить еще',
      en: 'Load more',
    },
  }
}

export class Lang {
  static lang = 'ru';

  static getLang() {
    return this.lang;
  }

  static setLang(lang) {
    this.lang = lang;

    if (this.getLang() === 'ru') {
      dayjs.locale('ru');
      const locale = {
        name: 'ru',
        monthsShort: [
          'янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'
        ],
        calendar: {
          lastDay: 'вчера в LT',
          sameDay: 'сегодня в LT',
          nextDay: 'завтра в LT',
          lastWeek: 'DD MMM в LT',
          nextWeek: 'DD MMM в LT',
          sameElse: 'DD MMM YYYY',
        }
      };
      dayjs.updateLocale('ru', locale);
    } else {
      this.lang = 'en';
      dayjs.locale('en');
      const locale = {
        name: 'en',
        monthsShort: [
          'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec',
        ],
      };
      dayjs.updateLocale('en', locale);
    }
  }

  static getKey(panel = '', key = '', defaultValue = '', vars = {}) {
    let value = ((Langs[panel] || {})[key] || {})[this.getLang()] || undefined;
    if (!value) {
      console.info('Ключ ' + panel + '.' + key + ' не найден');
      Sentry.captureMessage('Ключ ' + panel + '.' + key + ' не найден');
      value = defaultValue;
    }

    return this.replace(value, vars);
  }

  static replace(value = '', vars = {}) {
    for (let varIndex in vars) {
      value = value.replace('%' + varIndex, vars[varIndex]);
    }

    return value;
  }

  static declOfNum(panel = '', key = '', number = 0, defaultValue = '', vars = {}) {
    const value = ((Langs[panel] || {})[key] || {})[this.getLang()] || undefined;
    if (value === undefined) {
      console.info('Ключ ' + panel + '.' + key + ' не найден');
      Sentry.captureMessage('Ключ ' + panel + '.' + key + ' не найден');
    }

    const castArray = value => Array.isArray(value) ? value : [value];
    let index = 0;
    if (castArray(value).length === 3) {
      index = ((number % 10 === 1) && (number % 100 !== 11)) ? 0 : (((number % 10 >= 2) && (number % 10 <= 4) && ((number % 100 < 10) || (number % 100 >= 20))) ? 1 : 2);
    } else {
      index = (number === 1) ? 0 : 1;
    }

    vars['number'] = number;

    return this.replace(value[index] || defaultValue, vars);
  }

  static dateFormatShort(date) {
    return dayjs(date).calendar(null);
    // return dayjs(date).format('DD MMM в HH:mm');
  }

  static dateFormatLong(date) {
    return dayjs(date).format('L LT');
  }

  static dateFormatToInput(date) {
    return dayjs(date).format('YYYY-MM-DDTHH:mm');
  }

  static formatPrice = (price) => {
    let formatter = new Intl.NumberFormat(this.getLang() === 'en' ? 'en-us' : 'ru-RU', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });

    return formatter.format(price);
  }
}
